import React, { useState } from 'react'
import Table from '../../../../components/Table'
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { loaderAction } from '../../../../redux/actions/Index';
import axios from 'axios';
import { environment } from '../../../../env';
import EmptyTable from '../../../../components/errorComponents/EmptyTable';
import PathName from '../../../../components/PathName/PathName';

const TenantAgeing = () => {
    const [tenantdetails, setTenantDetails] = useState([]);
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);


    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm();
    const dateDiff = (data, id) => {
        const curDate = moment().format('YYYY-MM-DD');
        const newDate = moment(data).format('YYYY-MM-DD');
        var today = moment(newDate)
        var rentEndDate = moment(curDate)
        let dateDif = today.diff(rentEndDate, 'days')
        if (dateDif >= 0) {
            return dateDif
        } else {
            const tenantdetailsdata = tenantdetails.filter((curElem) => {
                return curElem.id !== id
            })
            setTenantDetails(tenantdetailsdata)
        }
    }
    const columns = [
        {
            name: 'Remaining day',
            selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                {row.terminate == true ?
                    <label className={`${row.days <= 60 && 'icon-bg-green icon-color-green '} ${row.days <= 30 && 'icon-bg-yellow icon-color-yellow'} ${row.days <= 10 && 'icon-bg-red icon-color-red'}   rounded-pill status-box rounded fs-4`}>
                        {row.days + ' ' + "Days"}</label> :
                    < label className={`${(dateDiff(row.rent_end_date, row.id) <= 60) && 'icon-bg-green icon-color-green '} ${(dateDiff(row.rent_end_date, row.id) <= 30) && 'icon-bg-yellow icon-color-yellow'} ${(dateDiff(row.rent_end_date, row.id) <= 10) && 'icon-bg-red icon-color-red'}   rounded-pill status-box rounded fs-4`}>
                        {dateDiff(row.rent_end_date, row.id) + ' ' + "Days"}</ label>
                }
            </div >,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Tenant Name',
            selector: row => row.proposal.name_of_company,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Building',
            selector: row => row.building.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Email',
            selector: row => row.proposal.company_email,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Contact No',
            selector: row => row.proposal.contact_number,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area',
            selector: row => (row.proposal.required_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Aggreement Start Date',
            selector: row => moment(row.aggrement_start_date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Rent End Date',
            selector: row => moment(row.rent_end_date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }
    ]
    const period = watch("period")
    const getTenant = async (params) => {
        dispatch(loaderAction(true))
        try {
            await axios.get(`${environment.baseUrl}add-gala-tenant/`).then((customerdata) => {
                let array = []
                let dataa = customerdata.data.filter((data) => data.project.id == userProject)
                dataa.map((data) => {
                    if (data.terminate != true) {
                        let date1 = moment(data.aggrement_end_date);
                        let date2 = moment().format('YYYY-MM-DD');
                        let days = date1.diff(date2, 'days')
                        if (params != 0) {
                            if (days <= params) {
                                array.push(data)
                            }
                        } else {
                            if (days <= 60) {
                                array.push(data)
                            }
                        }
                    } else {
                        if (data.status != 'vacated' || data.status != 'Vacated') {
                            let date1 = moment(data.rent_end_date);
                            let date2 = moment().format('YYYY-MM-DD');
                            let days = date1.diff(date2, 'days')
                            if (params != 0) {
                                if (days <= params) {
                                    data.days = days
                                    array.push(data)
                                }
                            } else {
                                if (days <= 60) {
                                    data.days = days
                                    array.push(data)
                                }
                            }
                        }
                    }

                })
                setTenantDetails(array);
                dispatch(loaderAction(false))
            })
        }
        catch (err) {
            dispatch(loaderAction(false))
            console.log(err);
        }

    }

    useEffect(() => {
        getTenant(60)
    }, [userProject])

    return (
        <>
            <PathName />
            <div className="tenant-history-main">
                <form >
                    <div className='my-4 row'>
                        <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                            <div className='w-100'>
                                <select
                                    className='p-3 shadow-none   w-100  title-font-500 fs-2  border-radius-10 modal-input '
                                    type='text'
                                    autoComplete='off'
                                    placeholder='Search Investor Here...'
                                    {...register('period', { onChange: (e) => { getTenant(e.target.value) } })}
                                >
                                    <option value={0}>Select number of Days</option>
                                    <option value={15}>15 Days</option>
                                    <option value={30}>30 Days</option>
                                    <option value={45}>45 Days</option>
                                    <option value={60}>60 Days</option>
                                </select>
                            </div>
                            <br />
                        </div>
                    </div>
                </form>
                <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center mb-5 ">
                        <h1 className='title-font-bold '>Ageing </h1>
                        <span className='fs-2 text-base-color base-font-600'>{period != 0 && `You selected ${period == 15 ? "( 15 day )" : period == 30 ? "( 1 Months )" : period == 45 ? "( 45 days )" : period == 60 && "( 2 Months )"}`}</span>
                    </div>
                    {tenantdetails?.length != 0 ? <Table columns={columns} data={tenantdetails} /> : <EmptyTable />}
                </div>
            </div>
        </>
    )
}

export default TenantAgeing